var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Abastecimento","titleIcon":"fas fa-gas-pump"}},[_c('form-abastecimento',{attrs:{"paramId":_vm.id},on:{"onSubmitAbastecimento":_vm.afterSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }